import React from "react"
import types from "prop-types"
import { isEqual } from "lodash-es"
import { useSelector } from "react-redux"
import { getFilteredReports } from "reduxSlices/reportIndexSlice"
import { CustomHeaderAccordion, useAccordion } from "shared/accordions"
import GroupingAccordionHeader from "shared/headers/GroupingAccordionHeader"
import ReportList from "./ReportList"

const ReportsSection = ({
  editPath,
  editScheduledReportExportPath,
  newReportExportPath,
  newScheduledReportExportPath,
  reportType,
  className = "",
  title,
}) => {
  const [isExpanded, toggleAccordion] = useAccordion(true)
  const reports = useSelector(getFilteredReports(reportType), isEqual)

  if (reports.length === 0) return null

  return (
    <section className={className}>
      <CustomHeaderAccordion
        isExpanded={isExpanded}
        header={(
          <GroupingAccordionHeader
            className="mb-4"
            groupName={title}
            isExpanded={isExpanded}
            toggleAccordion={toggleAccordion}
          />
        )}
        content={(
          <ReportList
            reportType={reportType}
            editPath={editPath}
            newReportExportPath={newReportExportPath}
            newScheduledReportExportPath={newScheduledReportExportPath}
            editScheduledReportExportPath={editScheduledReportExportPath}
          />
        )}
      />
    </section>
  )
}

ReportsSection.propTypes = {
  reportType: types.string.isRequired,
  editPath: types.func.isRequired,
  newReportExportPath: types.func.isRequired,
  newScheduledReportExportPath: types.func.isRequired,
  editScheduledReportExportPath: types.func.isRequired,
  className: types.string,
  title: types.string.isRequired,
}

export default ReportsSection
